import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getSortedErrors, selectFormDataStatus } from '@redux/selectors/FormSelector';
import ErrorMessage from './ErrorMessage';

const ValidationFeedback = () => {
  const [isFormDataLoaded, setIsFormDataLoaded] = useState(false);
  const errors = useSelector(getSortedErrors);
  const formDataStatus = useSelector(selectFormDataStatus);

  useEffect(() => {
    if (formDataStatus === 'initialized') setIsFormDataLoaded(true);
  }, [formDataStatus]);

  // this flashes. because validation is null, runs against a blank form, runs twice more, then is null again
  return (
    <ol id="validationList" className="list-group">
      {(isFormDataLoaded) ? errors.map(item => (
        <ErrorMessage
          key={Object.keys(item)}
          item={item}
        />
      )) : null}
    </ol>
  );
};

export default ValidationFeedback;
